export const salesRouteActions = {
    SALES_ROUTE_CREATE: 'SALES_ROUTE_CREATE',
    SALES_ROUTE_UPDATE: 'SALES_ROUTE_UPDATE',
    SALES_ROUTE_ASSIGN_RETAILER: 'SALES_ROUTE_ASSIGN_RETAILER',
    SALES_ROUTE_UNASSIGN_RETAILER: 'SALES_ROUTE_UNASSIGN_RETAILER',
};
